import { render, staticRenderFns } from "./UserDeleteBtn.vue?vue&type=template&id=7f50bb52&"
import script from "./UserDeleteBtn.vue?vue&type=script&lang=ts&"
export * from "./UserDeleteBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports